import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=78b96cfe&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"
import style0 from "./personal.vue?vue&type=style&index=0&id=78b96cfe&prod&lang=css"
import style1 from "./personal.vue?vue&type=style&index=1&id=78b96cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b96cfe",
  null
  
)

export default component.exports